
import { Component, Vue } from "vue-property-decorator";
import _ from "lodash-es";
import { CitySubjectConfig } from "@/lib/model/exam/xueersi";
import AuthHeader from "@/components/layout/auth-header.vue";

@Component({
  components: {
    AuthHeader
  }
})
export default class Xueersi extends Vue {
  name = "xueersi";
  citySubjectConfigs = new Array<CitySubjectConfig>();
  selectedCitySubjectConfig = new CitySubjectConfig();
  selectedtrainingTimeListText = "";

  city = "";
  subject = "";
  status = "";
  trainingTime = "";
  dialogVisible = false;

  get cities(): string[] {
    return _.uniq(
      _.map(this.citySubjectConfigs, item => {
        return item.cityName;
      })
    );
  }

  get subjects(): string[] {
    const configs = _.filter(this.citySubjectConfigs, citySubjectConfig => {
      return citySubjectConfig.cityName === this.city;
    });
    return _.uniq(
      _.map(configs, config => {
        return config.subjectName;
      })
    );
  }

  get trainingTimes(): string[] {
    for (const i in this.citySubjectConfigs) {
      const config = this.citySubjectConfigs[i];
      if (
        this.city === config.cityName &&
        this.subject === config.subjectName
      ) {
        return config.trainingTimeList;
      }
    }
    return [];
  }

  get filteredCitySubjectConfigs() {
    return _.filter(this.citySubjectConfigs, config => {
      const okCity = _.isEmpty(this.city)
        ? true
        : config.cityName === this.city;
      const okSubject = _.isEmpty(this.subject)
        ? true
        : config.subjectName === this.subject;
      const okTrainingTime = _.isEmpty(this.trainingTime)
        ? true
        : config.trainingTimeList.indexOf(this.trainingTime) > 0;
      const okStatus =
        this.status === "" ? true : config.status === +this.status;
      return okCity && okSubject && okTrainingTime && okStatus ? true : false;
    });
  }

  mounted() {
    CitySubjectConfig.list().then(citySubjectConfigs => {
      this.citySubjectConfigs = citySubjectConfigs;
    });
  }

  changeSearchCity() {
    this.subject = "";
    this.trainingTime = "";
  }

  changeSearchSubject() {
    this.trainingTime = "";
  }

  changeSearchStatus() {
    //TODO
  }

  changeSearchTrainingTime() {
    //TODO
  }

  search() {
    return CitySubjectConfig.list().then(citySubjectConfigs => {
      this.citySubjectConfigs = citySubjectConfigs;
      return citySubjectConfigs;
    });
  }

  close(c: CitySubjectConfig) {
    const updateObj = _.clone(c);
    updateObj.status = 1;
    CitySubjectConfig.update(updateObj).then(() => {
      c.status = 1;
    });
  }

  open(c: CitySubjectConfig) {
    const updateObj = _.clone(c);
    updateObj.status = 0;
    CitySubjectConfig.update(updateObj).then(() => {
      c.status = 0;
    });
  }

  showSetTime(c: CitySubjectConfig) {
    this.selectedCitySubjectConfig = c;
    this.dialogVisible = true;
    this.selectedtrainingTimeListText = c.trainingTimeList.join("\n");
  }

  updateTrainingTime() {
    const updateObj = _.clone(this.selectedCitySubjectConfig);
    let s = _.trim(this.selectedtrainingTimeListText, "\n\r \t");
    s = _.replace(s, /\r\n/g, "\n");
    s = _.replace(s, /\r/g, "\n");
    updateObj.trainingTimeList = s.split("\n");
    CitySubjectConfig.update(updateObj).then(() => {
      this.selectedCitySubjectConfig.trainingTimeList =
        updateObj.trainingTimeList;
      this.dialogVisible = false;
    });
  }
}
